(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  const prepareHeroVideos = (root = document) => {
    root.querySelectorAll('.hero video.hero__media').forEach((video) => {
      if (video.dataset.autoplayReady) return;
      video.dataset.autoplayReady = 'true';
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      const start = () => {
        if (document.hidden || !video.paused) return;
        const playback = video.play();
        if (playback) playback.catch(() => {});
      };
      video.addEventListener('loadeddata', start);
      video.addEventListener('canplay', start);
      video.closest('.hero')?.addEventListener('pointerdown', (event) => {
        if (!event.target.closest('a, button, input, select, textarea')) start();
      }, { passive: true });
      document.addEventListener('visibilitychange', start);
      window.addEventListener('pageshow', start);
      start();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => prepareHeroVideos(), { once: true });
  } else {
    prepareHeroVideos();
  }
  document.addEventListener('shopify:section:load', (event) => prepareHeroVideos(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
